import lodashGet from 'lodash/get'
import lodashSet from 'lodash/set'
import lodashCloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export default defineNuxtPlugin((nuxtApp) => {

    return {
        provide: {
            log: (string) => {
                console.log(string)
            },
            df: (date, format = null) => {
                const {d: $d} = useI18n();
                return $d(date.toDate() ?? date, format)
            },
            moment: moment,
            get: lodashGet,
            set: lodashSet,
            cloneDeep: lodashCloneDeep,
            getCookie: (cookieName) => {
                let b = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
                return b ? b.pop() : '';
            },
            roundCommercially: (number) => {
                if (!number || (typeof number !== "string" && typeof number !== "number")) return number
                if (typeof number === "string") number = parseFloat(number)
                if (!number) return 0
                return (Math.round((number + (Number.EPSILON * Math.sign(number))) * 100) / 100)
            }
        }
    };
})